import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MessageCircle, Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F14] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-xl bg-[#25D366] flex items-center justify-center">
            <MessageCircle className="w-7 h-7 text-[#0B0F14]" strokeWidth={2.5} />
          </div>
          <h1 className="font-heading text-2xl font-extrabold text-slate-50">LeadFlow.WA</h1>
        </div>
        <div className="bg-[#111822] border border-[#1E2D3D] rounded-2xl p-8 shadow-2xl">
          {sent ? (
            <div className="text-center py-4" data-testid="forgot-success">
              <MailCheck className="w-12 h-12 text-[#25D366] mx-auto mb-4" />
              <h2 className="font-heading text-xl font-bold text-slate-100 mb-2">Revisa tu correo</h2>
              <p className="text-sm text-slate-400">Si el correo existe, enviamos un enlace para restablecer tu contraseña. Expira en 1 hora.</p>
            </div>
          ) : (
            <>
              <h2 className="font-heading text-xl font-bold text-slate-100 mb-1">Recuperar contraseña</h2>
              <p className="text-sm text-slate-400 mb-6">Te enviaremos un enlace por correo</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label className="text-slate-300 mb-2 block">Correo</Label>
                  <Input
                    data-testid="forgot-email-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="bg-[#0B0F14] border-[#1E2D3D] text-slate-100 h-11"
                    required
                  />
                </div>
                {error && <p className="text-sm text-red-400">{error}</p>}
                <Button data-testid="forgot-submit-button" disabled={loading} className="w-full h-11 bg-[#25D366] hover:bg-[#22BF5B] text-[#0B0F14] font-semibold">
                  {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Enviar enlace"}
                </Button>
              </form>
            </>
          )}
          <div className="mt-6 text-center">
            <Link to="/login" className="text-sm text-slate-400 hover:text-[#25D366] inline-flex items-center gap-1">
              <ArrowLeft className="w-4 h-4" /> Volver a iniciar sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
